<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :close-on-click="false"
    :nudge-right="0"
    transition="scale-transition"
    offset-y
    max-width="300px"
    class="v-menu"
    hide-details
  >
    <template #activator="{ on, attrs }">
      <!-- <v-btn
        outlined
        v-bind="attrs"
        class="text-none"
        height="39px"
        v-on="on"
      >
        <v-icon left>
          mdi-calendar-range-outline
        </v-icon>
        {{ `${value[0]} ~ ${value[1]}` }}
        <v-icon right>
          mdi-chevron-down
        </v-icon>
      </v-btn> -->
      <v-text-field
        :value="`${value[0]} ~ ${value[1]}`"
        :label="$t('helper.chooseDate')"
        prepend-inner-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        outlined
        hide-details
        dense
        style="max-width: 250px;"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="dates"
      flat
      no-title
      full-width
      range
      :locale="locale"
      hide-details
    >
      <v-spacer />
      <v-btn
        text
        class="text-none"
        color="secondary"
        @click="menu = false"
      >
        {{ $t('helper.cancel') }}
      </v-btn>
      <v-btn
        text
        class="text-none"
        color="primary"
        :disabled="dates.length === 0"
        @click="handleChange(false)"
      >
        {{ $t('helper.agree') }}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DateRangePicker',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      menu: false,
      dates: [new Date().toISOString().substring(0, 10), new Date().toISOString().substring(0, 10)],
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  created() {
    this.$emit('input', this.dates);
  },
  methods: {
    handleChange(isClose) {
      if (this.dates.length === 1) {
        this.$emit('input', [this.dates[0], this.dates[0]]);
        this.$emit('change', [this.dates[0], this.dates[0]]);
      }
      if (this.dates.length === 2) {
        const date0num = new Date(this.dates[0]).getTime();
        const date1num = new Date(this.dates[1]).getTime();
        if (date0num > date1num) {
          this.dates = [this.dates[1], this.dates[0]];
        }
        this.$emit('input', this.dates);
        this.$emit('change', this.dates);
      }
      this.menu = isClose;
    },
  },
};
</script>

<style scoped>
</style>
